"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("@chakra-ui/react");
var _atoms = require("@whitbread-eos/atoms");
var _molecules = require("@whitbread-eos/molecules");
var _utils = require("@whitbread-eos/utils");
var _react2 = _interopRequireWildcard(require("react"));
var _dateUtils = require("../utils/common/date-utils");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var MonthTabsCarousel = _ref => {
  var {
    maxMonths = 12,
    initialMonthValue,
    onMonthChange,
    language,
    locale = 'en-GB',
    setLowestPrice,
    lowestPrice,
    isLoading
  } = _ref;
  var months = (0, _react2.useMemo)(() => (0, _dateUtils.generateMonthData)(maxMonths, locale), [maxMonths, locale]);
  var {
    scrollRef,
    scrollToLeft,
    scrollToRight,
    canScrollLeft,
    canScrollRight,
    hasOverflow,
    checkScrollButtons
  } = (0, _utils.useHorizontalScroll)(146);
  var handleScrollLeft = () => {
    scrollToLeft();
  };
  var handleScrollRight = () => {
    scrollToRight();
  };
  var [activeMonthValue, setActiveMonthValue] = (0, _react2.useState)(() => {
    var _months$;
    if (initialMonthValue && months.some(m => m.value === initialMonthValue)) {
      return initialMonthValue;
    }
    return ((_months$ = months[0]) === null || _months$ === void 0 ? void 0 : _months$.value) || '';
  });
  (0, _react2.useEffect)(() => {
    var el = scrollRef.current;
    if (!el) return;
    var handleScroll = () => {
      checkScrollButtons();
    };
    el.addEventListener('scroll', handleScroll);
    checkScrollButtons();
    return () => el.removeEventListener('scroll', handleScroll);
  }, [scrollRef, checkScrollButtons]);
  (0, _react2.useEffect)(() => {
    if (initialMonthValue && months.some(m => m.value === initialMonthValue)) {
      setActiveMonthValue(initialMonthValue);
    }
  }, [initialMonthValue, months]);
  var handleTabClick = monthData => {
    setActiveMonthValue(monthData.value);
    if (setLowestPrice && (monthData === null || monthData === void 0 ? void 0 : monthData.value) !== activeMonthValue) {
      setLowestPrice({
        price: 0,
        currency: ''
      });
    }
    if (onMonthChange) onMonthChange(monthData);
  };
  return (0, _jsxRuntime.jsxs)(_react.Box, _objectSpread(_objectSpread({}, styles.container), {}, {
    children: [(0, _jsxRuntime.jsx)(_react.Box, _objectSpread(_objectSpread({
      ref: scrollRef
    }, styles.scrollContainer), {}, {
      onScroll: checkScrollButtons,
      children: (0, _jsxRuntime.jsx)(_react.Flex, _objectSpread(_objectSpread({}, styles.innerTrack), {}, {
        children: months.map(month => (0, _jsxRuntime.jsx)(_atoms.MonthTab, {
          language: language,
          label: month.label,
          price: lowestPrice === null || lowestPrice === void 0 ? void 0 : lowestPrice.price,
          isActive: month.value === activeMonthValue,
          onClick: () => handleTabClick(month),
          "data-month-value": month.value,
          currencySymbol: lowestPrice === null || lowestPrice === void 0 ? void 0 : lowestPrice.currency,
          isLoading: isLoading
        }, month.value))
      }))
    })), hasOverflow && canScrollLeft && (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [(0, _jsxRuntime.jsx)(_react.Box, _objectSpread({}, styles.leftGradient)), (0, _jsxRuntime.jsx)(_react.Box, _objectSpread(_objectSpread({}, styles.leftScrollButton), {}, {
        children: (0, _jsxRuntime.jsx)(_molecules.ScrollButton, {
          direction: "left",
          onClick: handleScrollLeft
        })
      }))]
    }), hasOverflow && canScrollRight && (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [(0, _jsxRuntime.jsx)(_react.Box, _objectSpread({}, styles.rightGradient)), (0, _jsxRuntime.jsx)(_react.Box, _objectSpread(_objectSpread({}, styles.rightScrollButton), {}, {
        children: (0, _jsxRuntime.jsx)(_molecules.ScrollButton, {
          direction: "right",
          onClick: handleScrollRight
        })
      }))]
    })]
  }));
};
var _default = exports.default = MonthTabsCarousel;
var styles = {
  container: {
    position: 'relative',
    w: 'full',
    px: {
      base: 2,
      md: 4
    }
  },
  scrollContainer: {
    overflowX: 'auto',
    w: 'full',
    sx: {
      '&::-webkit-scrollbar': {
        display: 'none'
      },
      '-ms-overflow-style': 'none',
      scrollbarWidth: 'none'
    }
  },
  innerTrack: {
    justify: 'flex-start',
    align: 'flex-end'
  },
  leftGradient: {
    position: 'absolute',
    left: {
      base: 2,
      md: 4
    },
    top: 0,
    bottom: 0,
    width: '80px',
    background: 'linear-gradient(to right, rgba(255,255,255,1) 60%, rgba(255,255,255,0.95) 30%, rgba(255,255,255,0.7) 80%, rgba(255,255,255,0) 100%)',
    zIndex: 10,
    pointerEvents: 'none'
  },
  rightGradient: {
    position: 'absolute',
    right: {
      base: 2,
      md: 4
    },
    top: 0,
    bottom: 0,
    width: '80px',
    background: 'linear-gradient(to left, rgba(255,255,255,1) 60%, rgba(255,255,255,0.95) 30%, rgba(255,255,255,0.7) 80%, rgba(255,255,255,0) 100%)',
    zIndex: 10,
    pointerEvents: 'none'
  },
  leftScrollButton: {
    position: 'absolute',
    left: {
      base: 4,
      md: 6
    },
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 20
  },
  rightScrollButton: {
    position: 'absolute',
    right: {
      base: 4,
      md: 6
    },
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 20
  }
};